import { z } from 'zod';

export const premiumSchema = z.number({ invalid_type_error: 'Ágio deve ser um número válido' })
  .min(-5, 'Ágio deve ser maior ou igual a -5')
  .max(5, 'Ágio deve ser menor ou igual a 5')
  .refine((val) => {
    const rounded = Math.round(val * 100) / 100;
    return Math.abs(val - rounded) < Number.EPSILON;
  }, 'Ágio deve ter no máximo 2 casas decimais');

export function validatePremium(value: number): null | string {
  const result = premiumSchema.safeParse(value);
  if (!result.success) {
    return result.error.errors[0]?.message || 'Valor inválido';
  }
  return null;
}
